import React, { useContext } from "react";
import LoginForm from "../../components/login/LoginForm";
import classes from "./Login.module.css";
import Topbar from "../../components/topbar/Topbar";
import AuthContext from "../../store/AuthContext";


const Login = () => {

  const authCtx = useContext(AuthContext);
  authCtx.authFalse();
  /*action="/" method="post">*/
  return (
    <div >
      <Topbar />
      <div className={classes.main}>
         <LoginForm />
      </div>
    </div>
  );
};

export default Login;

//      <div className={`${classes.main} ${classes.body}`}>
